import axiosPost from '../axiosPost';

export const formatosXTipoDeImagenDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "FormatoXTipoDeImagenDel",
        "params": {
            "formatosXTipoDeImagenId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}